import _ from 'lodash-es'
import { Action, Getter, Module, Mutation, VuexModule } from 'types-vue'
import { ActionContext } from 'vuex'
import UnprocessedFilesApi from '../connections/api/UnprocessedFiles'
import { UnprocessedFile } from '../models'
import { UnprocessedFilesResponse } from '../models/api'

@Module({ namespaced: true })
export default class UnprocessedFiles extends VuexModule {

  private _unprocessedFilesList: UnprocessedFile[] = []
  private _pageSize: number = 10
  private _currentPage: number = 1
  private _totalElements: number = 0
  private _listLoading: boolean = true

  @Getter() public unprocessedList(): UnprocessedFile[] { return this._unprocessedFilesList}
  @Getter() public pageSize(): number { return this._pageSize }
  @Getter() public currentPage(): number { return this._currentPage }
  @Getter() public totalElements(): number { return this._totalElements }
  @Getter() public listLoading(): boolean { return this._listLoading }

  @Mutation()
  protected setUnprocessedFiles(data: UnprocessedFilesResponse) {
    this._unprocessedFilesList = data.files
    this._totalElements = data.totalElements
    this._listLoading = false
  }

  @Mutation()
  protected setCurrentPage(currentPage: number) {
    this._currentPage = currentPage
  }

  @Mutation()
  protected setPageSize(pageSize: number) {
    this._pageSize = pageSize
  }

  @Mutation()
  protected setListLoading(value: boolean) {
    this._listLoading = value
  }

  @Action({ commit: 'setCurrentPage' }) protected updateCurrentPage(currentPage) { return currentPage }


  @Action({ commit: 'setUnprocessedFiles', useContext: true })
  protected async obtainUnprocessedFiles(ctx: ActionContext<any, any>): Promise<UnprocessedFilesResponse> {
    const page = ctx.getters.currentPage - 1
    const size = ctx.getters.pageSize
    const sort = 'createdAt,DESC'

    if (_.isNil(page) || _.isNil(size)) return

    ctx.commit('setListLoading', true)
    const response = await UnprocessedFilesApi.getUnprocessedFiles({ page, size, sort })

    return response.data
  }


  @Action({ useContext: true })
  protected newPageSize(ctx: ActionContext<any, any>, pageSize: number): void {
    ctx.commit('setPageSize', pageSize)
  }


  @Action({ useContext: true })
  protected async removeUnprocessed(ctx: ActionContext<any, any>, file: UnprocessedFile): Promise<any> {
    const response = await UnprocessedFilesApi.removeById(file.keyname)

    if (response.status === 200)
      ctx.dispatch('obtainBills')
  }
}
